import store from "@/app/store/store";
export class HttpHelper {
    /**
     * Handle HTTP reponse. Will redirect to login page upon encountering a 401 exception.
     */
    static handleResponse(response, callback) {
        try {
            if (response.status === 401) {
                store.dispatch("loginModule/logoutRedirect");
                return;
            }
            return callback();
        }
        catch (ex) {
            return callback();
        }
    }
}
